const integrationTypes = ['LOAD_INTEGRATIONS'];

export default integrationTypes;
